import { css } from 'emotion';
import {
  mobileMaxWidthBreakpoint,
  burnedOrange,
  lightGrey,
  grey,
} from 'inside-out/global-styles';


export const filtersGroupStyle = css({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  [`@media (max-width: ${ mobileMaxWidthBreakpoint }px)`]: {
    height: 'auto',
  },
});

export const typeFiltersGroupStyle = css({
  height: '120px',
});

export const disciplineFiltersGroupStyle = css({
  height: '150px',
  marginBottom: '20px',
});

export const ageFiltersGroupStyle = css({
  height: '110px',
  paddingRight: '13px',
  '& > label': {
    width: '230px',
    marginRight: '0',
  }
});

export const serviceFiltersGroupStyle = css({
  height: '60px',
  width: '230px',
  '& > label': {
    marginRight: '0',
  }
});

export const filtersLabelStyle = css({
  marginRight: '45px',
  marginBottom: '10px',
  paddingLeft: '22px',
  fontSize: '16px',
  fontWeight: '400',
  color: grey,
  position: 'relative',
  '& > input': {
    position: 'absolute',
    opacity: '0',
    cursor: 'pointer',
  },
  '& > .checkmark': {
    marginRight: '4px',
    position: 'absolute',
    top: '1px',
    left: '0',
    height: '18px',
    width: '18px',
    backgroundColor: lightGrey,
    border: `1px solid ${ grey }`,
    opacity: '0.3',
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'none',
    }
  },
  '& input[type=radio] ~ .checkmark': {
    borderRadius: '50%',
    '&:after': {
      top: '2px',
      left: '2px',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: burnedOrange,
    }
  },
  '& input[type=checkbox] ~ .checkmark': {
    width: '16px',
    height: '16px',
    top: '2px',
    left: '1px',
    borderRadius: '3px',
    '&:after': {
      top: '2px',
      left: '5px',
      width: '5px',
      height: '8px',
      border: 'solid #fff',
      borderWidth: '0 2px 2px 0',
      transform: 'rotate(45deg)',
    }
  },
  '&:hover input ~ .checkmark': {
    opacity: '0.5',
  },
  '& input[type=radio]:checked ~ .checkmark': {
    opacity: '1',
    borderColor: burnedOrange,
    backgroundColor: '#fff',
  },
  '& input[type=checkbox]:checked ~ .checkmark': {
    opacity: '1',
    borderColor: burnedOrange,
    backgroundColor: burnedOrange,
  },
  '& input:checked ~ .checkmark:after': {
    display: 'block',
  },
});



// WEBPACK FOOTER //
// ./src/components/treatment-services/filters/styles.js